/**
 * Product-admin jobs list + journal (WSRPDM-0073 / WSRAPI-0108 / 0109).
 *
 * Raw DTOs, no `unwrap()` — mirrors `./notifications.ts`. Envelope is
 * `PagedResponse` `content`. All omits the filter param; size default 20,
 * server max 100 (not notifications' 200).
 *
 * `status=all` / `severity=all` are NOT valid query values — omit the param
 * entirely for "all". `request()`'s `buildUrl` already skips `undefined`
 * query values (`../client.ts`), so passing `status: undefined` here is
 * sufficient — never pass the literal string `'all'` / `'ALL'`.
 */
import { request } from '../client';
import type { PagedResponse } from '../types';
import type { IngestionJobView, QueueJobStatus, SyncDecisionView } from './types';

export interface ListJobsQuery {
  status?: QueueJobStatus | undefined;
  type?: string | undefined;
  page?: number;
  size?: number;
}

export interface ListDecisionsQuery {
  severity?: 'INFO' | 'WARN' | 'ERROR' | undefined;
  page?: number;
  size?: number;
}

/** GET /admin/platform/tenants/{slug}/jobs (WSRAPI-0109). */
export async function listJobs(
  slug: string,
  query: ListJobsQuery = {},
): Promise<PagedResponse<IngestionJobView>> {
  const { status, type, page = 0, size = 20 } = query;
  return request<PagedResponse<IngestionJobView>>(
    'GET',
    `/admin/platform/tenants/${slug}/jobs`,
    { query: { status, type, page, size } },
  );
}

/** GET /admin/platform/tenants/{slug}/jobs/{jobId}/decisions (WSRAPI-0108). */
export async function listDecisions(
  slug: string,
  jobId: number,
  query: ListDecisionsQuery = {},
): Promise<PagedResponse<SyncDecisionView>> {
  const { severity, page = 0, size = 20 } = query;
  return request<PagedResponse<SyncDecisionView>>(
    'GET',
    `/admin/platform/tenants/${slug}/jobs/${jobId}/decisions`,
    { query: { severity, page, size } },
  );
}
